import React from "react";
import { Popup } from "@emisgroup/ui-popup";
import { Button } from "@emisgroup/ui-button";
import InfoNotification from "~icons/ic/baseline-info";

interface ITypesPopupProps {
  className: string;
}

export const TypesPopup: React.FC<ITypesPopupProps> = ({ className }) => {
  return (
    <Popup>
      <Popup.Trigger>
        <Button borderless={true} variant="mono" className={className}>
          <InfoNotification title={""}/>
        </Button>
      </Popup.Trigger>
      <Popup.Content>
        <div style={{ padding: "0.5rem 1rem" }}>
          <div><b>Execution types</b></div>
          <div><b>Multiple sites</b> allow you to enter a number of sites based on Postcode.</div>
          <div><b>DSA</b> is an execution based on selected Data sharing agreements.</div>
          <div><b>Organisation CDB</b> is based on provision of a number of Organisation CDB</div>
        </div>
      </Popup.Content>
    </Popup>
  );
};
